import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2, AlertCircle, Clock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../services/api';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [status, setStatus] = useState('verifying');
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setStatus('error');
      setError('Token de vérification manquant.');
      return;
    }

    verifyEmail(token);
  }, [searchParams]);

  const verifyEmail = async (token) => {
    try {
      const response = await authAPI.verifyEmail(token);
      if (response.data.pendingApproval) {
        setStatus('pending');
        return;
      }
      login(response.data.token, response.data.user);
      setStatus('success');
      setTimeout(() => {
        navigate('/qso');
      }, 2000);
    } catch (err) {
      setStatus('error');
      setError(err.response?.data?.error || 'Erreur lors de la vérification de l\'email.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-12 px-4 card-shadow border border-[#E5E7EB] sm:rounded-2xl sm:px-10">
          {status === 'verifying' && (
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 border-4 border-[#2563EB] border-t-transparent rounded-full animate-spin mb-6"></div>
              <h2 className="text-xl font-bold text-[#1F2937] mb-2">Vérification en cours...</h2>
              <p className="text-[#6B7280]">Veuillez patienter</p>
            </div>
          )}

          {status === 'success' && (
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <CheckCircle2 className="w-8 h-8 text-green-600" />
              </div>
              <h2 className="text-xl font-bold text-[#1F2937] mb-2">Email vérifié !</h2>
              <p className="text-[#6B7280] mb-4">
                Votre compte a été activé avec succès.
              </p>
              <p className="text-sm text-[#6B7280]">
                Redirection en cours...
              </p>
            </div>
          )}

          {status === 'pending' && (
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-6">
                <Clock className="w-8 h-8 text-blue-500" />
              </div>
              <h2 className="text-xl font-bold text-[#1F2937] mb-2">Email confirmé !</h2>
              <p className="text-[#6B7280] mb-4">
                Votre adresse email a bien été vérifiée. Votre compte est maintenant en attente d'approbation par un administrateur du club.
              </p>
              <p className="text-sm text-[#6B7280] mb-6">
                Vous recevrez un email dès que votre accès sera activé.
              </p>
              <button
                onClick={() => navigate('/auth')}
                className="btn-base btn-primary w-full"
              >
                Retour à la connexion
              </button>
            </div>
          )}

          {status === 'error' && (
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                <AlertCircle className="w-8 h-8 text-red-600" />
              </div>
              <h2 className="text-xl font-bold text-[#1F2937] mb-2">Erreur de vérification</h2>
              <p className="text-[#6B7280] mb-6">{error}</p>
              <button
                onClick={() => navigate('/auth')}
                className="btn-base btn-primary w-full"
              >
                Retour à la connexion
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
